import { Pie } from '@ant-design/plots'
import { Empty } from 'antd'

const PieChart = ({ data, theme = 'classicDark', colorKey, pieColors }) => {
  if (!data || data.length === 0) {
    return (
      <div
        style={{
          height: 200,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme === 'classicDark' ? '#141414' : '#f5f5f5',
        }}
      >
        <Empty description="No Data Available" />
      </div>
    )
  }

  const config = {
    theme,
    data,
    angleField: 'value',
    colorField: 'key',
    tooltip: false,
    legend: false,
    colors: ['#ff69b4', '#267dd4'],
    label: {
      text: ({ key, value }) => `${key}: ${(value * 100).toFixed(0)}%`,
      fill: '#fff',
      fontSize: 14,
    },
    style: {
      padding: 10,
      fill: ({ key }) => {
        if (key === colorKey) {
          return pieColors[1]
        }
        return pieColors[0]
      },
    },
  }

  return (
    <div style={{ width: 300, height: 300, marginLeft: 15 }}>
      <Pie {...config} />
    </div>
  )
}

export default PieChart
